import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import AIChat from "../analytics/AIChat";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function InventoryItem() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [owners, setOwners] = useState([]);
    const [categories, setCategories] = useState([]);
    const [editId, setEditId] = useState(null);
    const units = [{
        value: "KG", label: "Kg"
    }, {
        value: "BAG", label: "Bag"
    }, {
        value: "BOX", label: "Box"
    }, {
        value: "LTR", label: "Litre"
    }, {
        value: "PCS", label: "Piece"
    }, {
        value: "TON", label: "Ton"
    }];
    const [formData, setFormData] = useState({
        owner: "", category: "", item_name: "", sku: "", unit: "", minimum_stock: "", status: 1
    });
    useEffect(() => {
        getItems();
        getOwners();
        getCategories();
    }, []);
    const getItems = () => {
        setLoading(true);
        axios.get(baseUrl + "inventory-item/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getOwners = () => {
        axios.get(baseUrl + "user-profile/")
            .then((res) => {
                setOwners(res.data);
            });
    };
    const getCategories = () => {
        axios.get(baseUrl + "inventory-category/")
            .then((res) => {
                setCategories(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            owner: "", category: "", item_name: "", sku: "", unit: "", minimum_stock: "", current_stock: "", status: 1
        });
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            owner: row.owner?.id,
            category: row.category?.id,
            item_name: row.item_name,
            sku: row.sku,
            unit: row.unit,
            minimum_stock: row.minimum_stock,
            current_stock: row.current_stock,
            status: row.status
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Inventory Item?", icon: "warning", showCancelButton: true
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`delete-inventory-item/${id}/`)
                        .then(() => {
                            Swal.fire("Deleted", "", "success");
                            getItems();
                        });
                }
            });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = new FormData();
            data.append("owner", formData.owner);
            data.append("category", formData.category);
            data.append("item_name", formData.item_name);
            data.append("sku", formData.sku);
            data.append("unit", formData.unit);
            data.append("minimum_stock", formData.minimum_stock);
            data.append("status", formData.status);
            data.append("addedby", userName);
            data.append("ip_add", ipAddress);
            if (editId === null) {
                await axios.post(baseUrl + "inventory-item/", data);
            } else {
                await axios.put(baseUrl + `update-inventory-item/${editId}/`, data);
            }
            Swal.fire("Success", editId === null ? "Inventory Item Saved" : "Inventory Item Updated", "success");
            clearForm();
            getItems();
        } catch (error) {
            Swal.fire("Error", "Unable to Save Inventory Item", "error");
        }
        setLoading(false);
    };
    const columns = [{
        field: "item_name", headerName: "Item Name", width: 220
    }, {
        field: "sku", headerName: "SKU", width: 150
    }, {
        field: "owner",
        headerName: "Owner",
        width: 180,
        renderCell: (params) => (<span>{params.row.owner?.name || ""}</span>)
    }, {
        field: "category",
        headerName: "Category",
        width: 180,
        renderCell: (params) => (<span>{params.row.category?.name || ""}</span>)
    }, {
        field: "unit", headerName: "Unit", width: 100
    }, {
        field: "minimum_stock", headerName: "Minimum Stock", width: 150
    }, {
        field: "current_stock", headerName: "Current Stock", width: 150, renderCell: (params) => (<strong>

                {params.row.current_stock}

            </strong>)
    }, {
        field: "status", headerName: "Status", width: 100, renderCell: (params) => (<span
                className={`badge ${params.row.status === 1 ? "bg-success" : "bg-danger"}`}
            >
                {params.row.status === 1 ? "Active" : "Inactive"}
            </span>)
    }, {
        field: "action",
        headerName: "Action",
        width: 180,
        sortable: false,
        filterable: false,
        renderCell: (params) => (<>
                <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => editData(params.row)}
                >
                    Edit
                </button>

                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteData(params.row.id)}
                >
                    Delete
                </button>
            </>)
    }];
    return (<div className="container-fluid mt-3">


        <div className="card shadow">


            <div className="card-header bg-success text-white">


                <h5 className="mb-0">

                    Inventory Item

                </h5>


            </div>


            <div className="card-body">


                <form onSubmit={saveData}>


                    <div className="row">


                        <div className="col-md-3 mb-3">


                            <label>

                                Owner

                            </label>


                            <select


                                className="form-control"


                                name="owner"


                                value={formData.owner}


                                onChange={handleChange}


                                required


                            >


                                <option value="">


                                    Select Owner


                                </option>


                                {owners.map((item) => (<option


                                    key={item.id}


                                    value={item.id}


                                >


                                    {item.name}


                                </option>))}


                            </select>


                        </div>


                        <div className="col-md-3 mb-3">


                            <label>

                                Category

                            </label>


                            <select


                                className="form-control"


                                name="category"


                                value={formData.category}


                                onChange={handleChange}


                                required


                            >


                                <option value="">


                                    Select Category


                                </option>


                                {categories.map((item) => (<option


                                    key={item.id}


                                    value={item.id}


                                >


                                    {item.name}


                                </option>))}


                            </select>


                        </div>


                        <div className="col-md-3 mb-3">


                            <label>

                                Item Name

                            </label>


                            <input


                                type="text"


                                className="form-control"


                                name="item_name"


                                value={formData.item_name}


                                onChange={handleChange}


                                required


                            />


                        </div>


                        <div className="col-md-3 mb-3">


                            <label>

                                SKU

                            </label>


                            <input


                                type="text"


                                className="form-control"


                                name="sku"


                                value={formData.sku}


                                onChange={handleChange}


                            />


                        </div>

                        <div className="col-md-3 mb-3">


                            <label>

                                Unit

                            </label>


                            <select


                                className="form-control"


                                name="unit"


                                value={formData.unit}


                                onChange={handleChange}


                                required


                            >


                                <option value="">


                                    Select Unit


                                </option>


                                {units.map((item) => (<option


                                    key={item.value}


                                    value={item.value}


                                >


                                    {item.label}


                                </option>))}


                            </select>


                        </div>


                        <div className="col-md-3 mb-3">


                            <label>

                                Minimum Stock

                            </label>


                            <input


                                type="number"


                                step="0.01"


                                className="form-control"


                                name="minimum_stock"


                                value={formData.minimum_stock}


                                onChange={handleChange}


                            />


                        </div>


                        <div className="col-md-3 mb-3">


                            <label>

                                Status

                            </label>


                            <select


                                className="form-control"


                                name="status"


                                value={formData.status}


                                onChange={handleChange}


                            >


                                <option value="1">

                                    Active

                                </option>


                                <option value="0">

                                    Inactive

                                </option>


                            </select>


                        </div>


                        <div className="col-md-12 mt-3">


                            <button


                                type="submit"


                                className="btn btn-success me-2"


                                disabled={loading}


                            >


                                {editId === null ? "Save Item" : "Update Item"}


                            </button>


                            <button


                                type="button"


                                className="btn btn-secondary"


                                onClick={clearForm}


                            >


                                Clear


                            </button>


                        </div>


                    </div>


                </form>


            </div>


        </div>

        <div className="card shadow mt-3">


            <div className="card-header bg-primary text-white">


                <h5 className="mb-0">

                    Inventory Item List

                </h5>


            </div>


            <div className="card-body">


                <div

                    style={{
                        height: 600, width: "100%"
                    }}

                >


                    <ERPDataGrid


                        rows={rows}


                        columns={columns}


                        loading={loading}


                        getRowId={(row) => row.id}


                        pageSizeOptions={[10, 25, 50, 100]}


                        disableRowSelectionOnClick


                    />


                </div>


            </div>


        </div>
        <AIChat agentCode="INVENTORY"/>

    </div>);
}
export default InventoryItem;